import { forwardRef as s } from "react";
import { hasOwnProperty as l } from "../../ariakit-utils/esm/misc.js";
import { jsx as f } from "react/jsx-runtime";
function u(o) {
  return typeof o == "function";
}
function h(o) {
  return /* @__PURE__ */ s((e, t) => o({
    ref: t,
    ...e
  }));
}
function R(o, i) {
  const {
    as: e,
    wrapElement: t,
    ...r
  } = i;
  let n;
  if (e && typeof e != "string")
    n = /* @__PURE__ */ f(e, {
      ...r
    });
  else if (u(i.children)) {
    const {
      children: m,
      ...c
    } = r;
    n = i.children(c);
  } else e ? n = /* @__PURE__ */ f(e, {
    ...r
  }) : n = /* @__PURE__ */ f(o, {
    ...r
  });
  return t ? t(n) : n;
}
function y(o) {
  return function(e) {
    e === void 0 && (e = {});
    const t = o(e), r = {};
    for (const n in t)
      l(t, n) && t[n] !== void 0 && (r[n] = t[n]);
    return r;
  };
}
export {
  h as createComponent,
  R as createElement,
  y as createHook
};
//# sourceMappingURL=system.js.map
